import React, { useState } from 'react';

const ImageComponent1 = ({ param, sup_cat }) => {
    const [src, setSrc] = useState(`/GWD/${param}.jpg`);

    const handleImageError = () => {
        if (sup_cat == 'Bearings') {
            setSrc('/GWD/Bearings.jpg')
        }
        else if (sup_cat === "Lubricants") setSrc('/GWD/LUBRICANTS.jpg')
        else if (sup_cat === 'Automotive') setSrc('/GWD/Autoparts.jpg')
        else if (sup_cat === 'Battery') setSrc('/GWD/BATTERY.jpg')
        else setSrc('/GWD/default.jpg')
    };

    return (
        <img
            src={src}
            onLoad={() => console.log('Image loaded successfully')}
            onError={handleImageError}
            alt="test.jpg"
            height={100}
            width={100}
        />
    );
};

export default ImageComponent1;
